<template>
  <img
    v-if="!isLoading"
    :style="styles"
    :src="imagePath"
  />
</template>

<script lang="ts" setup>
  import { useImage } from '@vueuse/core';
  import { onMounted, ref } from 'vue';

  const props = defineProps({
    path: {
      type: String,
      default: null,
    },
    styles: {
      type: String,
      default: `
          position: relative;
          width: 100%;
          height: 100%;
        `,
    },
  });

  const imagePath = ref('');
  const { isLoading } = useImage({ src: imagePath.value });

  onMounted(async () => {
    try {
      const images = import.meta.glob('../assets/**/*.{jpg,jpeg,png,gif,svg,webp}');
      const imageModule = images[`../assets/${props.path}`];
      if (imageModule) {
        const module = (await imageModule()) as { default: string };
        imagePath.value = module.default;
      } else {
        console.error('Image not found:', props.path);
      }
    } catch (error) {
      console.error('Error loading image:', error);
    }
  });
</script>
<style scoped></style>
